<template>
  <div class="bg-white">
    <!-- Header -->
    <div class="relative pb-32 bg-gray-800">
      <div class="absolute inset-0">
        <!--
        <img
          class="w-full h-full object-cover"
          src="https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixqx=xc9myIFc3S&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=60&&sat=-100"
          alt=""
        />
        -->


        <img
          class="w-full h-full object-cover"
          src="/images/header.jpg"
          alt=""
        />

        <!--
          Этот блок "затемняет" фоновую картинку%
        <div
          class="absolute inset-0 bg-gray-800"
          style="mix-blend-mode: multiply"
          aria-hidden="true"
        >
        </div>
        -->
      </div>
      <div
        class="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8"
      >
        <h1
          class="max-w-4xl mx-auto text-center text-2xl uppercase font-bold tracking-tight text-white md:text-5xl lg:text-6xl"
        >
          Развивайтесь в медицине <br/>вместе с нами
          <!--
          Образовательная <br />
          платформа <br />
          Фонда Доказательной Медицины
          -->
        </h1>
        <p class="text-center mx-auto mt-6 max-w-3xl text-xl text-gray-300">
          <!-- Start learning with us! -->
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // dropDownToggled: false,
    };
  },
  methods: {
    // toggleDropDown() {
    //   this.dropDownToggled = !this.dropDownToggled;
    // },
  },
};
</script>


